// could be removed when get rid of renderProps in favor of children?
'use client';

import { IRegistrationFormSchemaResponse } from '@/hooks/api/fetchRegistrationFormSchema/useRegistrationFormSchema.interfaces';

interface ILoginProps {
    loginSchemaResponse: ILoginFormSchemaResponse;
    registrationSchemaResponse: IRegistrationFormSchemaResponse;
}

import React from 'react';
import styles from './index.module.scss';
import { Stepper } from '@/components/common/Stepper/Stepper';
import { Step } from '@/components/common/Step/Step';
import { LoginAndRegister } from '@/components/login-and-register/LoginAndRegister';
import { RecoverPassword } from '@/components/recover-password/RecoverPassword';
import { useTranslation } from '@app/i18n/useTranslationClient';
import { ILoginFormSchemaResponse } from '@/hooks/api/fetchLoginFormSchema/useLoginFormSchema.interfaces';

export const Login: React.FC<ILoginProps> = (loginProps) => {
    const {
        t,
        i18n: { language },
    } = useTranslation();

    return (
        <div className={styles.wrapper}>
            <Stepper initialStep={1}>
                <Step
                    render={(props) => {
                        return (
                            <div className={styles.content}>
                                <div className={styles.contentTitle}>{t('translations.login.joinTitle')}</div>
                                <LoginAndRegister
                                    onNextStep={props.onNextStep}
                                    loginSchema={loginProps.loginSchemaResponse}
                                    registrationSchema={loginProps.registrationSchemaResponse}
                                />
                            </div>
                        );
                    }}
                />
                <Step
                    render={(props) => {
                        return (
                            <div data-testid={'resetPasswordForm'}>
                                <div>
                                    <RecoverPassword onPrevStep={props.onPrevStep} />
                                </div>
                            </div>
                        );
                    }}
                />
            </Stepper>
        </div>
    );
};
